import React from "react";
import { motion } from "framer-motion";
import { PhoneCall, Truck, Sparkles, ArrowRight } from "lucide-react";

const STEPS = [
  {
    num: "01",
    icon: PhoneCall,
    title: "Call or request a quote",
    desc: "Tell us what you've got. We'll give you a flat, upfront price — usually in minutes.",
  },
  {
    num: "02",
    icon: Truck,
    title: "We show up on time",
    desc: "Our uniformed crew arrives in the window we promised — insured and ready to work.",
  },
  {
    num: "03",
    icon: Sparkles,
    title: "We haul it away & clean up",
    desc: "We load everything, sweep the space, and leave it looking better than we found it.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="bg-navy text-white py-24 sm:py-32 relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 font-display text-gold/5 text-[22rem] leading-none uppercase select-none pointer-events-none hidden lg:block">
        EASY
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-3xl">
          <span className="label-pill !bg-transparent !border-white/60 !text-white">
            <span className="h-1.5 w-1.5 bg-gold" />
            05 — How it works
          </span>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[0.95]">
            Three steps.
            <br />
            <span className="text-gold">Zero stress.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-2 border-white/20">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.num}
                data-testid={`step-${i + 1}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                className={`relative p-8 sm:p-10 ${
                  i < STEPS.length - 1 ? "md:border-r-2 border-white/20" : ""
                } ${i < STEPS.length - 1 ? "border-b-2 md:border-b-0 border-white/20" : ""}`}
              >
                <span className="absolute top-6 right-6 font-display text-[5rem] sm:text-[6rem] leading-none text-white/10">
                  {s.num}
                </span>
                <div className="h-16 w-16 flex items-center justify-center bg-gold text-navy border-2 border-gold mb-8">
                  <Icon className="h-8 w-8" strokeWidth={2.5} />
                </div>
                <h3 className="font-display uppercase text-2xl sm:text-3xl leading-tight max-w-xs">
                  {s.title}
                </h3>
                <p className="mt-4 font-body text-white/75 text-base leading-relaxed max-w-sm">
                  {s.desc}
                </p>
                {i < STEPS.length - 1 && (
                  <ArrowRight className="hidden md:block absolute top-1/2 -right-3 -translate-y-1/2 h-6 w-6 text-gold bg-navy border-2 border-white/20" />
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
